import {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Page from '../page';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false, error: null};
  }

  static getDerivedStateFromError(error) {
    // Update state to trigger fallback UI
    return {hasError: true, error: error.toString()};
  }

  componentDidCatch(error, errorInfo) {
    // Log error or send logging data to log management tool
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Page title="Hyperblox IDE">
          <Grid container style={{height: '100vh'}} direction="row" alignContent="center" justify="center" alignItems="center">
            <Grid item xs={12}>
              <Grid style={{textAlign: 'center'}}>
                <Typography variant="h3">Something went wrong...</Typography>
              </Grid>
              {this.state.error && (
                <Grid style={{textAlign: 'center'}}>
                  <Typography variant="h3">{this.state.error}</Typography>
                </Grid>
              )}
            </Grid>

            <Grid item xs={12} style={{textAlign: 'center', paddingTop: 25}}>
              <Button className="searchButtonHotels" variant="contained" href={'/'} color="primary">
                Go back Home
              </Button>
            </Grid>
          </Grid>
        </Page>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
